const ElectoralDistricts = {
    ANNAPOLIS: "Annapolis",
    ANTIGONISH: "Antigonish",
    ARGYLE: "Argyle",
    BEDFORD_BASIN: "Bedford Basin",
    BEDFORD_SOUTH: "Bedford South",
    CAPE_BRETON_CENTRE_WHITNEY_PIER: "Cape Breton Centre-Whitney Pier",
    CAPE_BRETON_EAST: "Cape Breton East",
    CHESTER_ST_MARGARETS: "Chester-St. Margaret's",
    CHETICAMP_MARGAREES_PLEASANT_BAY: "Chéticamp-Margarees-Pleasant Bay",
    CLARE: "Clare",
    CLAYTON_PARK_WEST: "Clayton Park West",
    COLCHESTER_MUSQUODOBOIT_VALLEY: "Colchester-Musquodoboit Valley",
    COLCHESTER_NORTH: "Colchester North",
    COLE_HARBOUR: "Cole Harbour",
    COLE_HARBOUR_DARTMOUTH: "Cole Harbour-Dartmouth",
    CUMBERLAND_NORTH: "Cumberland North",
    CUMBERLAND_SOUTH: "Cumberland South",
    DARTMOUTH_EAST: "Dartmouth East",
    DARTMOUTH_NORTH: "Dartmouth North",
    DARTMOUTH_SOUTH: "Dartmouth South",
    DIGBY_ANNAPOLIS: "Digby-Annapolis",
    EASTERN_PASSAGE: "Eastern Passage",
    EASTERN_SHORE: "Eastern Shore",
    FAIRVIEW_CLAYTON_PARK: "Fairview-Clayton Park",
    GLACE_BAY_DOMINION: "Glace Bay-Dominion",
    GUYSBOROUGH_TRACADIE: "Guysborourgh-Tracadie",
    HALIFAX_ARMDALE: "Halifax Armdale",
    HALIFAX_ATLANTIC: "Halifax Atlantic",
    HALIFAX_CHEBUCITO: "Halifax Chebucto",
    HALIFAX_CITADEL_SABLE_ISLAND: "Halifax Citadel-Sable Island",
    HALIFAX_NEEDHAM: "Halifax Needham",
    HAMMONDS_PLAINS_LUCASVILLE: "Hammonds Plains-Lucasville",
    HANTS_EAST: "Hants East",
    HANTS_WEST: "Hants West",
    INVERNESS: "Inverness",
    KINGS_NORTH: "Kings North",
    KINGS_SOUTH: "Kings South",
    KINGS_WEST: "Kings West",
    LUNENBURG: "Lunenburg",
    LUNENBURG_WEST: "Lunenburg West",
    NORTHSIDE_WESTMOUNT: "Northside Westmount",
    PICTOU_CENTRE: "Pictou Centre",
    PICTOU_EAST: "Pictou East",
    PICTOU_WEST: "Pictou West",
    PRESTON: "Preston",
    QUEENS: "Queens",
    RICHMOND: "Richmond",
    SACKVILLE_COBEQUID: "Sackville-Cobequid",
    SACKVILLE_UNIACKE: "Sackville-Uniacke",
    SHELBURNE: "Shelburne",
    SYDNEY_MEMBERTOU: "Sydney-Membertou",
    TIMBERLEA_PROSPECT: "Timberlea-Prospect",
    TRURO_BIBLE_HILL_MILLBROOK_SALMON_RIVER: "Truro-Bible Hill-Millbrook-Salmon River",
    VICTORIA_THE_LAKES: "Victoria-The Lakes",
    WAVERLEY_FALL_RIVER_BEAVER_BANK: "Waverley-Fall River-Beaver Bank",
    YARMOUTH: "Yarmouth"
}


export default ElectoralDistricts;